import React, { useState, useRef, useEffect } from "react";
import {
  Menu,
  X,
  ShoppingCart,
  User,
  LogOut,
  UserCircle,
  Package,
  Plus,
} from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import userIcon from "../assets/download.png";
import { logout } from "../Redux/slices/authSlice";

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, token } = useSelector((state) => state.auth);
  const isLoggedIn = !!token;
  const isAgent = user?.type === "agent";

  console.log("user", user);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    toast.success("Logged out successfully!");
    navigate("/", { replace: true });
    setTimeout(() => {
      dispatch(logout());
    }, 100);
    setIsDropdownOpen(false);
    setIsMenuOpen(false);
  };

  const AgentBadge = () => (
    <div className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
      A
    </div>
  );

  return (
    <nav className="bg-white custom-nav-shadow fixed top-0 left-0 w-full z-50">
      <div className="sm:w-[100%] md:w-[100%] lg:w-[90%] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Link
                to="/"
                className="loginLogo text-center text-2xl font-extrabold tracking-wide text-[#6cb34e] mb-3"
              >
                MB-SOURCE
              </Link>
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-6">
            {isLoggedIn &&
              isAgent &&
              location.pathname !== "/agent-add-product" && (
                <Link
                  to="/agent-add-product"
                  className="flex items-center space-x-2 bg-[#101b45] hover:bg-[#101b45] text-white px-4 py-2 rounded-lg font-medium transition"
                >
                  <Plus className="w-4 h-4" />
                  <span>Upload Product</span>
                </Link>
              )}

            <button className="relative hover:text-[#101b45] transition">
              <ShoppingCart className="w-5 h-5" />
            </button>

            {isLoggedIn ? (
              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="flex items-center space-x-2 hover:opacity-80 transition relative"
                >
                  {user?.profile_pic ? (
                    <div className="relative">
                      <img
                        src={user.profile_pic}
                        alt={user?.name || "User"}
                        className="w-9 h-9 rounded-full object-cover"
                        loading="lazy"
                      />
                      {isAgent && <AgentBadge />}
                    </div>
                  ) : (
                    <div className="relative">
                      <img
                        src={userIcon}
                        alt="User"
                        className="w-9 h-9 rounded-full"
                      />
                      {isAgent && <AgentBadge />}
                    </div>
                  )}
                </button>

                {isDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
                    {isAgent && (
                      <div className="px-4 py-2 border-b border-gray-200">
                        <span className="text-xs font-semibold text-[#101b45] uppercase">
                          Agent Account
                        </span>
                      </div>
                    )}
                    <Link
                      to="/profile"
                      onClick={() => setIsDropdownOpen(false)}
                      className="flex items-center space-x-2 px-4 py-2 text-gray-700 hover:bg-gray-100 transition"
                    >
                      <UserCircle className="w-4 h-4" />
                      <span>Profile</span>
                    </Link>

                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center space-x-2 px-4 py-2 text-gray-700 hover:bg-gray-100 transition"
                    >
                      <LogOut className="w-4 h-4" />
                      <span>Logout</span>
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Link
                  to="/login"
                  className="flex items-center space-x-1 text-sm hover:text-[#101b45] transition"
                >
                  <User className="w-4 h-4" />
                  <span>Sign in</span>
                </Link>

                <Link
                  to="/signUp"
                  className="bg-[#101b45] hover:bg-[#101b45] text-white px-6 py-2 rounded-full font-medium transition"
                >
                  Create account
                </Link>
              </>
            )}
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#101b45] transition"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 pt-4 pb-6 space-y-4">
            <button className="w-full flex items-center space-x-2 py-2 border-b">
              <ShoppingCart className="w-5 h-5" />
              <span>Cart</span>
            </button>

            {isLoggedIn ? (
              <>
                <div className="flex items-center space-x-3 py-2 border-b">
                  <div className="relative">
                    {user?.profile_pic ? (
                      <>
                        <img
                          src={user.profile_pic}
                          alt={user?.name || "User"}
                          className="w-10 h-10 rounded-full object-cover"
                          loading="lazy"
                        />
                        {isAgent && <AgentBadge />}
                      </>
                    ) : (
                      <>
                        <img
                          src={userIcon}
                          alt="User"
                          className="w-10 h-10 rounded-full"
                        />
                        {isAgent && <AgentBadge />}
                      </>
                    )}
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">
                      {user?.name}
                      {isAgent && (
                        <span className="ml-2 text-xs bg-blue-100 text-[#101b45] px-2 py-0.5 rounded-full">
                          Agent
                        </span>
                      )}
                    </p>
                    <p className="text-sm text-gray-500">{user?.email}</p>
                  </div>
                </div>

                <Link
                  to="/profile"
                  onClick={() => setIsMenuOpen(false)}
                  className="w-full flex items-center space-x-2 py-2 border-b"
                >
                  <UserCircle className="w-5 h-5" />
                  <span>Profile</span>
                </Link>

                {isAgent && (
                  <Link
                    to="/agent-add-product"
                    onClick={() => setIsMenuOpen(false)}
                    className="w-full flex items-center space-x-2 py-2 bg-[#101b45] text-white rounded-lg hover:bg-[#101b45] transition px-3"
                  >
                    <Package className="w-5 h-5" />
                    <span>Upload Product</span>
                  </Link>
                )}

                <button
                  onClick={handleLogout}
                  className="w-full flex items-center space-x-2 py-3 text-red-600 hover:text-red-700 transition"
                >
                  <LogOut className="w-5 h-5" />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/"
                  onClick={() => setIsMenuOpen(false)}
                  className="w-full flex items-center space-x-2 py-2 border-b"
                >
                  <User className="w-5 h-5" />
                  <span>Sign in</span>
                </Link>

                <Link
                  to="/signUp"
                  onClick={() => setIsMenuOpen(false)}
                  className="w-full bg-[#101b45] hover:bg-[#101b45] text-white py-3 rounded-full font-medium transition text-center"
                >
                  Create account
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
